import { IconProps } from "../../utils/global-types/global-types";

const SortAZIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M5.764 2a.656.656 0 0 0-.657.656v9.787l-.729-.165a.603.603 0 0 0-.649.9l1.518 2.52c.234.388.799.388 1.033 0l1.518-2.52a.603.603 0 0 0-.649-.9l-.73.165V2.656A.656.656 0 0 0 5.765 2M14.326 7.114l-1.637-4.582a.77.77 0 0 0-.722-.508h-.058a.77.77 0 0 0-.722.508L9.551 7.114a.576.576 0 1 0 1.089.379l.176-.522h2.244l.177.522a.576.576 0 1 0 1.088-.38m-3.133-1.231.737-2.16h.017l.736 2.16zM13.934 11.365a.767.767 0 0 0-.615-1.225h-2.875a.57.57 0 1 0 0 1.138h2.093v.017l-2.594 3.48A.767.767 0 0 0 10.558 16h2.95a.57.57 0 0 0 0-1.139H11.34v-.016z"
    ></path>
  </svg>
);

export default SortAZIcon;
